import * as angular from 'angular';
import './styling.scss';
import * as template from './template.html';

import { CurrentUserService } from 'services/currentUser';
import { IAugmentedJQuery } from 'angular';

const module = angular.module('home-checkup-section', []);

interface HomeCheckupSectionController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;

    sectionTitle: string;
    sectionDescription: string;
}

module.component('homeCheckupSection', {
    template: template,
    bindings: {
        policyInfo: '<'
    },
    controller: function(this: HomeCheckupSectionController) {
        function getSectionDescription(inspection: Inspection) {
            if (inspection.internal) {
                return `We are required to conduct a brief inspection of your home as part of our underwriting process.
                        At the time of your inspection a friendly Hippo representative, contracted through our friends
                        at CIS Inspection Services, will stop by your property to photograph the interior and exterior
                        of your home. This will help us assess the condition of your property.`;
            } else {
                return `We required to conduct a brief exterior inspection of your home as part of our underwriting
                        process. At the time of your inspection a friendly Hippo representative, contracted through our
                        friends at CIS Inspection Services, will stop by your property to photograph the exterior of
                        your home. This will help us assess the condition of your property.`;
            }
        }

        this.$onInit = () => {
            this.sectionTitle = 'Home Checkup';

            const inspection = this.policyInfo.inspection;

            if (inspection) {
                this.sectionDescription = getSectionDescription(inspection);
            }
        };
    }
});

export { module };
